import { Routes } from '@angular/router';
import { NewsletterContainerComponent } from './newsletter-container/newsletter-container.component';
import { MainNewsletterComponent } from './main-newsletter/main-newsletter.component';
import { NewsletterCoversComponent } from './newsletter-covers/newsletter-covers.component';

export const NEWSLETTER_ROUTES: Routes = [
    {path: '', component: NewsletterContainerComponent, children: [
        {path : "newsletter", component: NewsletterCoversComponent,
    data: {
      title: 'Explore the monthly company updates of Kalpita | Newsletter',
      description: 'Stay informed with Kalpita\'s monthly newsletter for the latest company updates, news, & exciting developments. Get a regular dose of information about us.',
      keywords: 'Newsletter'
    }},
    {path : "news-month", component: MainNewsletterComponent,
      data: {
        title: 'Kalpita Technologies Newsletter | Monthly Company Updates',
        description: 'Get the latest updates from Kalpita Technologies\' Newsletter! Stay informed on company news, innovations, and key developments with our monthly newsletters.',
        keywords: 'AI, software, business updates, tech trends, innovations, company updates'
      }
    }
    ]}
]